function formatDateYMD(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
}
function htmlEscape(str = '') {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
function htmlToText(html = '') {
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').trim();
}
function truncate(str = '', n = 160) {
  const s = String(str ?? '');
  return s.length > n ? s.slice(0, n) + '…' : s;
}
function buildArticleURL(articleHandle, blogHandle) {
  const root = (window.Shopify?.routes?.root ?? '/').replace(/\/$/, '');
  const bh = blogHandle || '';
  return bh ? `${root}/blogs/${bh}/${articleHandle}` : '#';
}

// build search query for ALL articles (no blog filter)
// Note: Storefront API only returns published articles by default
function buildQuery() {
  // Storefront API automatically filters to published articles
  // Add additional filters here if needed (e.g., tag filters)
  return '';
}
